export default "__VITE_ASSET__ed9111a7__"